import React from "react";
import './portfolio.css'
import { projects } from "../../data/profile";


const Portfolio = () => {
    return(
        <section id="portfolio">
            <div className="container">
                <span className="section__eyebrow">LLM Workflows</span>
                <h2 className="section__title">Projects</h2>

                <div className="portfolio__container">
                    {projects.map(({ title, description, highlights, stack }) => (
                        <article key={title} className="portfolio__item reveal">
                            <h3>{title}</h3>
                            <p className="text-muted">{description}</p>
                            <ul className="portfolio__highlights text-muted">
                                {highlights.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                            <ul className="portfolio__stack">
                                {stack.map((tech) => <li key={tech} className="tag">{tech}</li>)}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Portfolio
